import http from "../http-common";

class CursoService {
  getAll() {
    return http.get("/cursos");
  }

  get(id) {
    return http.get(`/cursos/${id}`);
  }

  create(data) {
    return http.post("/cursos", data);
  }

  update(id, data) {
    return http.put(`/cursos/${id}`, data);
  }

  delete(id) {
    return http.delete(`/cursos/${id}`);
  }

  getTrashed() {
    return http.get("/cursos/trashed/list");
  }

  restore(id) {
    return http.post(`/cursos/${id}/restore`);
  }
}

export default new CursoService();
